import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import useAllProduct from "../../../../../hooks/useAllProduct";
import SingleProduct from "../SingleProduct";
import { useEffect, useState } from "react";

const AllProduct = () => {
  const [allProduct] = useAllProduct()

  return (
    <>
      <Container>
        <Row className="mt-5">
          {allProduct.map((product) => (
            <Col md="3" key={product?._id}>
              <SingleProduct info={product}></SingleProduct>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default AllProduct;
